module.exports = __webpack_public_path__ + "static/media/Viking607_4c.201f362c.svg";